import { Action, Reducer } from "redux";
import { MunicipalityState, MunicipalityTypes, MunicipalityActionTypes } from "./municipalityTypes";

export const INITIAL_STATE: MunicipalityState = {
	municipality: {
		data: null,
		errorMessages: null,
		isError: false,
		isLoading: false,
	},
};

const municipalityReducer: Reducer<MunicipalityState> = (state: MunicipalityState = INITIAL_STATE, action: Action) => {
	const actionTypes = action as MunicipalityActionTypes;
	switch (actionTypes.type) {
		case MunicipalityTypes.GET_MUNICIPALITY:
			return {
				...state,
				municipality: { ...state.municipality, isLoading: true },
			};
		case MunicipalityTypes.SAVE_MUNICIPALITY:
			return {
				...state,
				municipality: {
					...state.municipality,
					isLoading: false,
					errorMessages: actionTypes.payload.errorMessages,
					isError: actionTypes.payload.isError,
					data: actionTypes.payload.data,
				},
			};
		case MunicipalityTypes.RESET_REDUCER_MUNICIPALITY:
			return {
				...state,
				municipality: INITIAL_STATE.municipality,
			};
		default:
			return state;
	}
};

export default municipalityReducer;
